export class TabStore<T> {
    public constructor(public activeTab: T) {
        //
    }

    public change(tab: T): void {
        this.activeTab = tab;
    }

    public isActive(tab: T): boolean {
        return this.activeTab === tab;
    }
}
